import * as React from "react";
import { useImperativeHandle, useRef, useState } from "react";
import styled from "styled-components";
import useDisclosure from "util/hooks/useDisclosure";
import Popover from "components/common/Popover";
import useClickOutside from "hooks/useClickOutside";
const TriggerWrap = styled.span`
  display: inline-flex;
`;
const Container = styled.div`
  display: inline-flex;
`;
const OverlayTrigger = ({
  children,
  disabled = false,
  placement,
  overlay,
  rootClose = false,
  trigger = "click",
  testId = void 0,
  className = void 0,
  title = void 0,
  width = 275
}, ref) => {
  var _a, _b, _c;
  const [opened, { close, open, toggle }] = useDisclosure(false);
  useImperativeHandle(
    ref,
    () => ({
      hide: close
    }),
    [close]
  );
  OverlayTrigger.hide = close;
  const containerRef = useRef();
  const [dropdown, setDropdown] = useState(null);
  const [control, setControl] = useState(null);
  useClickOutside(rootClose ? close : () => {
  }, null, [control, dropdown]);
  const hover = trigger === "hover" || ((_a = trigger == null ? void 0 : trigger.includes) == null ? void 0 : _a.call(trigger, "hover"));
  const focus = trigger === "focus" || ((_b = trigger == null ? void 0 : trigger.includes) == null ? void 0 : _b.call(trigger, "focus"));
  const click = trigger === "click" || ((_c = trigger == null ? void 0 : trigger.includes) == null ? void 0 : _c.call(trigger, "click"));
  return disabled ? children : /* @__PURE__ */ React.createElement(Container, { ref: containerRef, "data-testid": testId, className }, /* @__PURE__ */ React.createElement(Popover, { opened, withArrow: true, width, position: placement, withinPortal: true }, /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement(
    TriggerWrap,
    {
      className: children.props.className,
      ref: setControl,
      role: "button",
      onClick: click ? toggle : void 0,
      onMouseEnter: hover ? open : void 0,
      onMouseLeave: hover ? close : void 0,
      onFocus: focus ? open : void 0,
      onBlur: focus ? open : void 0
    },
    children
  )), /* @__PURE__ */ React.createElement(Popover.Dropdown, { title }, /* @__PURE__ */ React.createElement("div", { ref: setDropdown }, overlay))));
};
export default React.forwardRef(OverlayTrigger);
